import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const opportunityService = {
  getAllOpportunities,
  getAllDto,
  getByAdvertiserId,
  getOpportunityById,
};

const { apiUrl } = defineConfig.OPPORTUNITY_SERVICE || { apiUrl: "https://api-alessiplatform.codesour.dev" };

function getAllDto() {
  const url = apiUrl + `/v1/opportunity/getAllDto`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllOpportunities(page = 0, perPage = 10, sortField = null, sortOrder = "DESC", queryParams = '') {
  let url = `${apiUrl}/v1/opportunity/list/page/${page}/perPage/${perPage}`;
  
  if (sortField) {
    url += `/sort/${sortOrder}/sortValue/${sortField}`;
  } else {
    url += `/sort/${sortOrder}`;
  }
  
  if (queryParams) {
    if (typeof queryParams === 'string') {
      const queryString = queryParams.startsWith('?') ? queryParams.substring(1) : queryParams;
      url += `?${queryString}`;
    } else if (typeof queryParams === 'object') {
      const queryString = Object.entries(queryParams)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');
      
      if (queryString) {
        url += `?${queryString}`;
      }
    }
  }
  
  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getByAdvertiserId(advertiserId) {
  const url = `${apiUrl}/v1/opportunity/getByAdvertiserId/${advertiserId}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getOpportunityById(opportunityId) {
  const url = `${apiUrl}/v1/opportunity/getOpportunityById/${opportunityId}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => {
      return res;
    });
}
